
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import StartofYear from "./StarofYear";
import TeamofQuarterForm from "./TeamofQuarterForm";


function TeamofQuarterMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <TeamofQuarterForm/>
            </BasicCard>
        </>
    )
}
export default TeamofQuarterMain;